import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Localize } from "../../app/lang/langs";
import moment from "moment";
import styles from "./ContractsView.module.css";
import {
  dateBodyTemplate,
  dateFilterTemplate,
  startDateBodyTemplate,
  endDateBodyTemplate,
  statusBodyTemplate,
  statusItemTemplate,
  createDropdownFilterTemplate,
} from "./contractsTableUtils";

export default function MissionsDataTable({
  data,
  filters,
  globalFilterValue,
  onGlobalFilterChange,
  onRowDoubleClick,
  onValueChange,
  scrollHeight,
  statuses,
  teamBodyTemplate,
}) {
  const dtRef = useRef(null);
  const date = moment().format("DD-MM-YYYY");

  const tableHeader = () => (
    <Row>
      <Col md={6}>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          />
        </IconField>
      </Col>
    </Row>
  );

  const statusRowFilterTemplate = createDropdownFilterTemplate(statuses, statusItemTemplate);

  return (
    <div className={styles.collabsCard}>
      <DataTable
        ref={dtRef}
        onValueChange={onValueChange}
        exportFilename={`Missions_export_${date}`}
        value={data}
        dataKey="id"
        paginator
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        rowsPerPageOptions={[10, 25, 50]}
        rows={25}
        scrollable
        scrollHeight={scrollHeight}
        sortMode="single"
        filters={filters}
        currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
        onRowDoubleClick={onRowDoubleClick}
        selectionMode="single"
        header={tableHeader}
      >
        <Column field="nom" filter filterPlaceholder="nom" header={Localize("Family Name")} sortable dataType="text" style={{ minWidth: "9rem" }} />
        <Column field="prenom" filter filterPlaceholder="prenom" header={Localize("Name")} sortable style={{ minWidth: "9rem" }} />
        <Column field="statut" header={Localize("Status")} sortable body={statusBodyTemplate} style={{ minWidth: "7rem" }} showFilterMatchModes={false} filter filterElement={statusRowFilterTemplate} />
        <Column field="client" header={Localize("Client")} sortable style={{ minWidth: "14rem" }} />
        <Column field="current_team_name" header={Localize("team_name")} body={teamBodyTemplate} sortable style={{ minWidth: "8rem" }} />
        <Column field="start_date" header={Localize("start_date")} body={startDateBodyTemplate} filter filterElement={dateFilterTemplate} sortable dataType="date" style={{ minWidth: "13rem" }} />
        <Column field="end_date" header={Localize("end_date")} body={endDateBodyTemplate} filter filterElement={dateFilterTemplate} sortable dataType="date" style={{ minWidth: "13rem" }} />
        <Column field="current_team_location" header={Localize("location")} sortable style={{ minWidth: "8rem" }} />
        <Column field="poste_name" header={Localize("poste_name")} sortable style={{ minWidth: "14rem" }} />
        <Column field="group_name" header={Localize("Groupe")} sortable style={{ minWidth: "14rem" }} />
        <Column field="created_at" header={Localize("created_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: "10rem" }} />
        <Column field="created_by" header={Localize("created_by")} sortable style={{ minWidth: "13rem" }} />
        <Column field="updated_at" header={Localize("updated_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: "10rem" }} />
        <Column field="updated_by" header={Localize("updated_by")} sortable style={{ minWidth: "13rem" }} />
      </DataTable>
    </div>
  );
}
